import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { twMerge } from 'tailwind-merge';
import { useTestId } from '../../hooks';
import { forwardRefWithName } from '../../utils';
import { themes } from './themes';
const sizeClasses = {
    4: 'w-4 h-4',
    6: 'w-6 h-6',
    10: 'w-10 h-10',
    20: 'w-20 h-20',
    32: 'w-32 h-32',
};
const weightClasses = {
    thin: 'border-2',
    medium: 'border-4',
    thick: 'border-8',
};
function SpinnerComponent(_a, ref) {
    var { theme = 'kyber', size = 20, className, testId = 'spinner', weight = 'medium' } = _a, props = __rest(_a, ["theme", "size", "className", "testId", "weight"]);
    const tid = useTestId(testId, props);
    const classList = twMerge('spinner', sizeClasses[size], className);
    const innerClassList = twMerge(weightClasses[weight], themes[theme]);
    return (_jsx("div", Object.assign({ ref: ref, className: classList }, tid(), props, { children: _jsx("div", { className: "spinner__inner", children: _jsx("div", { className: innerClassList }) }) })));
}
export const Spinner = forwardRefWithName(SpinnerComponent);
//# sourceMappingURL=Spinner.js.map